<div class="cd-wrapper">

  <button class="cd-close-btn" (click)="closeBtnOnClick()">
    <i class="fa-solid fa-xmark"></i>
  </button>


  <div class="cd-icon-wrap">
    <ng-container *ngComponentOutlet="iconToShow"></ng-container>
  </div>


  <h2 class="cd-title">{{ data.header }}</h2>
  <p class="cd-message">{{ data.message }}</p>

  @if(!data.actionBtnsVisbile) {
  <div class="cd-actions">
    @for(buttonField of buttonList; track idx; let idx = $index) {
    <app-button-field onKeyDown="" (click)="onClose(buttonField.name)" [buttonConfig]="buttonField"
      [class.cd-btn-secondary]="idx === 0" [class.cd-btn-primary]="idx !== 0">
    </app-button-field>
    }
  </div>
  }
</div>